// import React, { useState, useEffect } from "react";
// import "./BOQAddDetails.css";
// import axios from "axios";
// import API_URL from "../../../src/Config";
// import Tooltip from "@mui/material/Tooltip";
// import { IoMdArrowBack } from "react-icons/io";
// import { useNavigate, useParams } from "react-router-dom";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import { MdFileDownload } from "react-icons/md";

// function BOQAddQtyForWeek({ isSidebarExpanded }) {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const { id, billing_frequency } = useParams();
//   const navigate = useNavigate();
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [billingFrequency, setBillingFrequency] = useState("weekly");
//   const [billingData, setBillingData] = useState(null);
//   const [isExporting, setIsExporting] = useState(false);

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const showSnackbar = (message, type = "success") => {
//     setSnackbarMessage(message);
//     setSeverity(type);
//     setSnackbarOpen(true);
//   };

//   const fetchBillingReport = async (frequency) => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.get(`${API_URL}/api/billing_report`, {
//         headers: { Authorization: authKey },
//         params: {
//           billing_frequency: frequency,
//           project_id: id,
//         },
//       });

//       console.log("Billing Report Data:", response.data);
//       setBillingData(response.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching billing report:", error.message);
//       setError(error.message);
//       showSnackbar("Failed to fetch billing report", "error");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBillingReport(billing_frequency);
//   }, [billing_frequency]);

//   const handleFrequencyChange = (frequency) => {
//     setBillingFrequency(frequency);
//   };

//   const handleExport = async () => {
//     try {
//       setIsExporting(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.get(`${API_URL}/api/billing_report/export`, {
//         headers: { Authorization: authKey },
//         params: {
//           billing_frequency: billingFrequency,
//           project_id: id,
//         },
//         responseType: "blob",
//       });

//       // Create download link
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
//       link.setAttribute(
//         "download",
//         `Billing_Report_${billingFrequency}_${timestamp}.xlsx`
//       );
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);

//       showSnackbar("Report exported successfully", "success");
//       setIsExporting(false);
//     } catch (error) {
//       console.error("Error exporting report:", error.message);
//       showSnackbar("Failed to export report", "error");
//       setIsExporting(false);
//     }
//   };

//   const handleBack = () => {
//     navigate("/amc-projects");
//   };

//   function formatNumber(number) {
//     if (!number) return "0";
//     const parts = number.toString().split(".");
//     const integerPart = parts[0];
//     const decimalPart = parts.length > 1 ? "." + parts[1] : "";

//     let formattedIntegerPart = "";
//     let lakhFlag = false;
//     let croreFlag = false;
//     let croreLakhFlag = false;

//     for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
//       if (count === 3 && !lakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         lakhFlag = true;
//       }

//       if (count === 2 && lakhFlag && !croreFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreFlag = true;
//       }

//       if (count === 2 && croreFlag && !croreLakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreLakhFlag = true;
//       }

//       formattedIntegerPart = integerPart[i] + formattedIntegerPart;
//     }

//     return formattedIntegerPart + decimalPart;
//   }

//   const renderMonthlyBreakdown = (serviceReport) => {
//     const { breakdown } = serviceReport;

//     return breakdown.map((period, index) => (
//       <tr key={index}>
//         {index === 0 && (
//           <>
//             <td rowSpan={breakdown.length} className="sticky-col boq-th1">
//               {serviceReport.service_code}
//             </td>
//             <td rowSpan={breakdown.length} className="sticky-col boq-th2">
//               {serviceReport.boq_info.description}
//             </td>
//             <td rowSpan={breakdown.length} className="sticky-col boq-th3">
//               {serviceReport.boq_info.uom}
//             </td>
//             <td rowSpan={breakdown.length} className="sticky-col boq-th4">
//               {serviceReport.boq_info.qty}
//             </td>
//             <td rowSpan={breakdown.length} className="sticky-col boq-th5">
//               ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
//             </td>
//             <td rowSpan={breakdown.length} className="sticky-col boq-th6">
//               ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
//             </td>
//           </>
//         )}
//         <td>{period.period}</td>
//         <td>{period.planned_qty}</td>
//         <td>{period.completed_qty}</td>
//         <td>{period.variance}</td>
//         <td>{period.completion_percentage}%</td>
//         <td>₹ {formatNumber(period.amount_without_gst)}</td>
//         <td>₹ {formatNumber(period.gst_amount)}</td>
//         <td>₹ {formatNumber(period.amount_with_gst)}</td>
//       </tr>
//     ));
//   };

//   const renderWeeklyBreakdown = (serviceReport) => {
//     const { breakdown } = serviceReport;
//     let totalRows = 0;

//     // Calculate total rows
//     breakdown.forEach((month) => {
//       totalRows += month.weeks.length;
//     });

//     let currentRow = 0;

//     return breakdown.map((month, monthIndex) => {
//       return month.weeks.map((week, weekIndex) => {
//         const isFirstRow = currentRow === 0;
//         currentRow++;

//         return (
//           <tr key={`${monthIndex}-${weekIndex}`}>
//             {isFirstRow && (
//               <>
//                 <td rowSpan={totalRows} className="sticky-col boq-th1">
//                   {serviceReport.service_code}
//                 </td>
//                 <td rowSpan={totalRows} className="sticky-col boq-th2">
//                   {serviceReport.boq_info.description}
//                 </td>
//                 <td rowSpan={totalRows} className="sticky-col boq-th3">
//                   {serviceReport.boq_info.uom}
//                 </td>
//                 <td rowSpan={totalRows} className="sticky-col boq-th4">
//                   {serviceReport.boq_info.qty}
//                 </td>
//                 <td rowSpan={totalRows} className="sticky-col boq-th5">
//                   ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
//                 </td>
//                 <td rowSpan={totalRows} className="sticky-col boq-th6">
//                   ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
//                 </td>
//               </>
//             )}
//             {weekIndex === 0 && (
//               <td rowSpan={month.weeks.length}>{month.month}</td>
//             )}
//             <td>{week.week}</td>
//             <td>{week.planned_qty}</td>
//             <td>{week.completed_qty}</td>
//             <td>{week.variance}</td>
//             <td>{week.completion_percentage}%</td>
//             <td>₹ {formatNumber(week.amount_without_gst)}</td>
//             <td>₹ {formatNumber(week.gst_amount)}</td>
//             <td>₹ {formatNumber(week.amount_with_gst)}</td>
//           </tr>
//         );
//       });
//     });
//   };

//   return (
//     <>
//       <div
//         className={`data-list-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="data-edit-form-content">
//           <div className="data-edit-form-header">
//             <div className="data-edit-form-header-content">
//               <div className="data-edit-form-heading-content-left-side">
//                 <Tooltip title="Back" arrow>
//                   <IoMdArrowBack
//                     className="back-company"
//                     onClick={handleBack}
//                   />
//                 </Tooltip>
//                 Billing Report
//               </div>
//               <div className="new_billing_ui_header_right">
//                 <div className="new_billing_ui_radio_group">
//                   <label className="new_billing_ui_radio_label">
//                     <input
//                       type="radio"
//                       name="frequency"
//                       value="weekly"
//                       checked={billingFrequency === "weekly"}
//                       onChange={() => handleFrequencyChange("weekly")}
//                     />
//                     <span>Weekly</span>
//                   </label>
//                   <label className="new_billing_ui_radio_label">
//                     <input
//                       type="radio"
//                       name="frequency"
//                       value="monthly"
//                       checked={billingFrequency === "monthly"}
//                       onChange={() => handleFrequencyChange("monthly")}
//                     />
//                     <span>Monthly</span>
//                   </label>
//                 </div>
//                 <button
//                   className="new_billing_ui_export_btn"
//                   onClick={handleExport}
//                   disabled={isExporting}
//                 >
//                   <MdFileDownload size={20} />
//                   {isExporting ? "Exporting..." : "Export"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="header-separator"></div>

//         {billingData && (
//           <div className="new_billing_ui_project_info">
//             <div className="new_billing_ui_info_item">
//               <strong>Project:</strong> {billingData.project_info.project_name}
//             </div>
//             <div className="new_billing_ui_info_item">
//               <strong>Duration:</strong>{" "}
//               {new Date(
//                 billingData.project_info.start_date
//               ).toLocaleDateString()}{" "}
//               to{" "}
//               {new Date(
//                 billingData.project_info.end_date
//               ).toLocaleDateString()}
//             </div>
//             <div className="new_billing_ui_info_item">
//               <strong>Service Codes:</strong>{" "}
//               {billingData.total_service_codes}
//             </div>
//           </div>
//         )}

//         <div className="data-list-body">
//           <div className="data-list-scroll-body-boq">
//             <div className="data-list-table-boq">
//               {loading ? (
//                 <div className="loader-container">
//                   <div className="loader"></div>
//                   <div>Loading...</div>
//                 </div>
//               ) : billingData &&
//                 billingData.service_code_reports.length > 0 ? (
//                 <table className="excel-table">
//                   <thead>
//                     <tr>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th1 new_boq_table_th"
//                       >
//                         Service Code
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th2 new_boq_table_th"
//                       >
//                         Description
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th3 new_boq_table_th"
//                       >
//                         UOM
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th4 new_boq_table_th"
//                       >
//                         Quantity
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th5 new_boq_table_th"
//                       >
//                         Unit Rate
//                       </th>
//                       <th
//                         rowSpan="2"
//                         className="sticky-col sticky-back boq-th6 new_boq_table_th"
//                       >
//                         Total Amount (with GST)
//                       </th>
//                       {billingFrequency === "weekly" && (
//                         <th rowSpan="2" className="new_boq_table_th">
//                           Month
//                         </th>
//                       )}
//                       <th rowSpan="2" className="new_boq_table_th">
//                         {billingFrequency === "weekly" ? "Week" : "Period"}
//                       </th>
//                       <th rowSpan="2" className="new_boq_table_th">
//                         Planned Qty
//                       </th>
//                       <th rowSpan="2" className="new_boq_table_th">
//                         Completed Qty
//                       </th>
//                       <th rowSpan="2" className="new_boq_table_th">
//                         Variance
//                       </th>
//                       <th rowSpan="2" className="new_boq_table_th">
//                         Completion %
//                       </th>
//                       <th rowSpan="2" className="new_boq_table_th">
//                         Amount (without GST)
//                       </th>
//                       <th rowSpan="2" className="new_boq_table_th">
//                         GST Amount
//                       </th>
//                       <th rowSpan="2" className="new_boq_table_th">
//                         Amount (with GST)
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {billingData.service_code_reports.map(
//                       (serviceReport, index) => (
//                         <React.Fragment key={index}>
//                           {billingFrequency === "monthly"
//                             ? renderMonthlyBreakdown(serviceReport)
//                             : renderWeeklyBreakdown(serviceReport)}
//                         </React.Fragment>
//                       )
//                     )}
//                   </tbody>
//                 </table>
//               ) : (
//                 <div>No billing data found.</div>
//               )}
//             </div>
//           </div>
//         </div>

//         {billingData && billingData.overall_summary && (
//           <div className="new_boq_totals_container">
//             <div className="new_boq_totals_row">
//               <div className="new_boq_totals_card">
//                 <div>
//                   <div className="new_boq_totals_title">Total Planned Qty</div>
//                   <div className="new_boq_totals_value">
//                     {billingData.overall_summary.total_planned_qty}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="new_boq_totals_title">
//                     Total Completed Qty
//                   </div>
//                   <div className="new_boq_totals_value">
//                     {billingData.overall_summary.total_completed_qty}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="new_boq_totals_title">Completion %</div>
//                   <div className="new_boq_totals_value">
//                     {billingData.overall_summary.completion_percentage}%
//                   </div>
//                 </div>
//               </div>

//               <div className="new_boq_totals_card">
//                 <div>
//                   <div className="new_boq_totals_title">
//                     Amount (without GST)
//                   </div>
//                   <div className="new_boq_totals_value">
//                     ₹{" "}
//                     {formatNumber(
//                       billingData.overall_summary.total_amount_without_gst
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="new_boq_totals_card gst">
//                 <div>
//                   <div className="new_boq_totals_title">GST Amount</div>
//                   <div className="new_boq_totals_value">
//                     ₹{" "}
//                     {formatNumber(
//                       billingData.overall_summary.total_gst_amount
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="new_boq_totals_card">
//                 <div>
//                   <div className="new_boq_totals_title">
//                     Total Amount (with GST)
//                   </div>
//                   <div className="new_boq_totals_value">
//                     ₹{" "}
//                     {formatNumber(
//                       billingData.overall_summary.total_amount_with_gst
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default BOQAddQtyForWeek;

// import React, { useState, useEffect } from "react";
// import "./BOQAddDetails.css";
// import axios from "axios";
// import API_URL from "../../../src/Config";
// import Tooltip from "@mui/material/Tooltip";
// import { IoMdArrowBack } from "react-icons/io";
// import { useNavigate, useParams } from "react-router-dom";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import { MdFileDownload } from "react-icons/md";

// function BOQAddQtyDetails({ isSidebarExpanded }) {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const { id, billing_frequency } = useParams();
//   const navigate = useNavigate();
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [billingFrequency, setBillingFrequency] = useState(
//     billing_frequency || "weekly"
//   );
//   const [billingData, setBillingData] = useState(null);
//   const [isExporting, setIsExporting] = useState(false);

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const showSnackbar = (message, type = "success") => {
//     setSnackbarMessage(message);
//     setSeverity(type);
//     setSnackbarOpen(true);
//   };

//   const fetchBillingReport = async (frequency) => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.get(`${API_URL}/api/billing_report`, {
//         headers: { Authorization: authKey },
//         params: {
//           billing_frequency: frequency,
//           project_id: id,
//         },
//       });

//       console.log("Billing Report Data:", response.data);
//       setBillingData(response.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching billing report:", error.message);
//       setError(error.message);
//       showSnackbar("Failed to fetch billing report", "error");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (id && billingFrequency) {
//       fetchBillingReport(billingFrequency);
//     }
//   }, [id, billingFrequency]);

//   const handleFrequencyChange = (frequency) => {
//     setBillingFrequency(frequency);
//     // Update URL to reflect frequency change
//     navigate(`/boq-add-details/${id}/${frequency}`, { replace: true });
//   };

//   const handleExport = async () => {
//     try {
//       setIsExporting(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.get(`${API_URL}/api/billing_report/export`, {
//         headers: { Authorization: authKey },
//         params: {
//           billing_frequency: billingFrequency,
//           project_id: id,
//         },
//         responseType: "blob",
//       });

//       // Create download link
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
//       link.setAttribute(
//         "download",
//         `Billing_Report_${billingFrequency}_${timestamp}.xlsx`
//       );
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);

//       showSnackbar("Report exported successfully", "success");
//       setIsExporting(false);
//     } catch (error) {
//       console.error("Error exporting report:", error.message);
//       showSnackbar("Failed to export report", "error");
//       setIsExporting(false);
//     }
//   };

//   const handleBack = () => {
//     navigate("/amc-projects");
//   };

//   function formatNumber(number) {
//     if (!number) return "0";
//     const parts = number.toString().split(".");
//     const integerPart = parts[0];
//     const decimalPart = parts.length > 1 ? "." + parts[1] : "";

//     let formattedIntegerPart = "";
//     let lakhFlag = false;
//     let croreFlag = false;
//     let croreLakhFlag = false;

//     for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
//       if (count === 3 && !lakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         lakhFlag = true;
//       }

//       if (count === 2 && lakhFlag && !croreFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreFlag = true;
//       }

//       if (count === 2 && croreFlag && !croreLakhFlag) {
//         formattedIntegerPart = "," + formattedIntegerPart;
//         count = 0;
//         croreLakhFlag = true;
//       }

//       formattedIntegerPart = integerPart[i] + formattedIntegerPart;
//     }

//     return formattedIntegerPart + decimalPart;
//   }

//   // Get all unique months from the breakdown data
//   const getAllMonths = () => {
//     if (!billingData || !billingData.service_code_reports.length) return [];

//     const monthsSet = new Set();

//     billingData.service_code_reports.forEach((serviceReport) => {
//       if (billingFrequency === "monthly") {
//         serviceReport.breakdown.forEach((period) => {
//           monthsSet.add(period.period);
//         });
//       } else {
//         // weekly
//         serviceReport.breakdown.forEach((month) => {
//           monthsSet.add(month.month);
//         });
//       }
//     });

//     return Array.from(monthsSet);
//   };

//   // Get all unique weeks for a given month (for weekly view)
//   const getWeeksForMonth = (monthName) => {
//     if (!billingData || !billingData.service_code_reports.length) return [];

//     const weeksSet = new Set();

//     billingData.service_code_reports.forEach((serviceReport) => {
//       const monthData = serviceReport.breakdown.find(
//         (m) => m.month === monthName
//       );
//       if (monthData && monthData.weeks) {
//         monthData.weeks.forEach((week) => {
//           weeksSet.add(week.week);
//         });
//       }
//     });

//     return Array.from(weeksSet).sort((a, b) => {
//       const aNum = parseInt(a.replace(/\D/g, ""), 10);
//       const bNum = parseInt(b.replace(/\D/g, ""), 10);
//       return aNum - bNum;
//     });
//   };

//   const renderHorizontalMonthlyView = () => {
//     if (!billingData || !billingData.service_code_reports.length) return null;

//     const months = getAllMonths();

//     return (
//       <table className="excel-table">
//         <thead>
//           <tr>
//             <th
//               rowSpan="2"
//               className="sticky-col sticky-back boq-th1 new_boq_table_th"
//             >
//               Service Code
//             </th>
//             <th
//               rowSpan="2"
//               className="sticky-col sticky-back boq-th2 new_boq_table_th"
//             >
//               Description
//             </th>
//             <th
//               rowSpan="2"
//               className="sticky-col sticky-back boq-th3 new_boq_table_th"
//             >
//               UOM
//             </th>
//             <th
//               rowSpan="2"
//               className="sticky-col sticky-back boq-th4 new_boq_table_th"
//             >
//               Quantity
//             </th>
//             <th
//               rowSpan="2"
//               className="sticky-col sticky-back boq-th5 new_boq_table_th"
//             >
//               Unit Rate
//             </th>
//             <th
//               rowSpan="2"
//               className="sticky-col sticky-back boq-th6 new_boq_table_th"
//             >
//               Total Amount (with GST)
//             </th>

//             {months.map((month, index) => (
//               <th colSpan="5" key={index} className="new_boq_table_th">
//                 {month}
//               </th>
//             ))}
//           </tr>
//           <tr>
//             {months.map((month, monthIndex) => (
//               <React.Fragment key={monthIndex}>
//                 <th className="new_boq_table_th new_billing_ui_sub_header">
//                   Planned
//                 </th>
//                 <th className="new_boq_table_th new_billing_ui_sub_header">
//                   Completed
//                 </th>
//                 <th className="new_boq_table_th new_billing_ui_sub_header">
//                   Variance
//                 </th>
//                 <th className="new_boq_table_th new_billing_ui_sub_header">
//                   Completion %
//                 </th>
//                 <th className="new_boq_table_th new_billing_ui_sub_header">
//                   Amount (GST)
//                 </th>
//               </React.Fragment>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {billingData.service_code_reports.map((serviceReport, index) => (
//             <tr key={index}>
//               <td className="sticky-col boq-th1">
//                 {serviceReport.service_code}
//               </td>
//               <td className="sticky-col boq-th2">
//                 {serviceReport.boq_info.description}
//               </td>
//               <td className="sticky-col boq-th3">
//                 {serviceReport.boq_info.uom}
//               </td>
//               <td className="sticky-col boq-th4">
//                 {serviceReport.boq_info.qty}
//               </td>
//               <td className="sticky-col boq-th5">
//                 ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
//               </td>
//               <td className="sticky-col boq-th6">
//                 ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
//               </td>

//               {months.map((month, monthIndex) => {
//                 const periodData = serviceReport.breakdown.find(
//                   (p) => p.period === month
//                 );

//                 return (
//                   <React.Fragment key={monthIndex}>
//                     <td>{periodData ? periodData.planned_qty : "-"}</td>
//                     <td>{periodData ? periodData.completed_qty : "-"}</td>
//                     <td
//                       className={
//                         periodData && periodData.variance < 0
//                           ? "new_billing_ui_negative_variance"
//                           : ""
//                       }
//                     >
//                       {periodData ? periodData.variance : "-"}
//                     </td>
//                     <td>
//                       {periodData ? `${periodData.completion_percentage}%` : "-"}
//                     </td>
//                     <td>
//                       {periodData
//                         ? `₹ ${formatNumber(periodData.amount_with_gst)}`
//                         : "-"}
//                     </td>
//                   </React.Fragment>
//                 );
//               })}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     );
//   };

//   const renderHorizontalWeeklyView = () => {
//     if (!billingData || !billingData.service_code_reports.length) return null;

//     const months = getAllMonths();
//     const monthWeeksMap = {};

//     // Build a map of months to their weeks
//     months.forEach((month) => {
//       monthWeeksMap[month] = getWeeksForMonth(month);
//     });

//     // Calculate total colspan for header
//     const totalWeekColumns = months.reduce(
//       (sum, month) => sum + monthWeeksMap[month].length,
//       0
//     );

//     return (
//       <table className="excel-table">
//         <thead>
//           <tr>
//             <th
//               rowSpan="3"
//               className="sticky-col sticky-back boq-th1 new_boq_table_th"
//             >
//               Service Code
//             </th>
//             <th
//               rowSpan="3"
//               className="sticky-col sticky-back boq-th2 new_boq_table_th"
//             >
//               Description
//             </th>
//             <th
//               rowSpan="3"
//               className="sticky-col sticky-back boq-th3 new_boq_table_th"
//             >
//               UOM
//             </th>
//             <th
//               rowSpan="3"
//               className="sticky-col sticky-back boq-th4 new_boq_table_th"
//             >
//               Quantity
//             </th>
//             <th
//               rowSpan="3"
//               className="sticky-col sticky-back boq-th5 new_boq_table_th"
//             >
//               Unit Rate
//             </th>
//             <th
//               rowSpan="3"
//               className="sticky-col sticky-back boq-th6 new_boq_table_th"
//             >
//               Total Amount (with GST)
//             </th>

//             {months.map((month, index) => (
//               <th
//                 colSpan={monthWeeksMap[month].length * 5}
//                 key={index}
//                 className="new_boq_table_th new_billing_ui_month_header"
//               >
//                 {month}
//               </th>
//             ))}
//           </tr>
//           <tr>
//             {months.map((month, monthIndex) =>
//               monthWeeksMap[month].map((week, weekIndex) => (
//                 <th
//                   colSpan="5"
//                   key={`${monthIndex}-${weekIndex}`}
//                   className="new_boq_table_th new_billing_ui_week_header"
//                 >
//                   {week}
//                 </th>
//               ))
//             )}
//           </tr>
//           <tr>
//             {months.map((month, monthIndex) =>
//               monthWeeksMap[month].map((week, weekIndex) => (
//                 <React.Fragment key={`${monthIndex}-${weekIndex}`}>
//                   <th className="new_boq_table_th new_billing_ui_sub_header">
//                     Planned
//                   </th>
//                   <th className="new_boq_table_th new_billing_ui_sub_header">
//                     Completed
//                   </th>
//                   <th className="new_boq_table_th new_billing_ui_sub_header">
//                     Variance
//                   </th>
//                   <th className="new_boq_table_th new_billing_ui_sub_header">
//                     Completion %
//                   </th>
//                   <th className="new_boq_table_th new_billing_ui_sub_header">
//                     Amount (GST)
//                   </th>
//                 </React.Fragment>
//               ))
//             )}
//           </tr>
//         </thead>
//         <tbody>
//           {billingData.service_code_reports.map((serviceReport, index) => (
//             <tr key={index}>
//               <td className="sticky-col boq-th1">
//                 {serviceReport.service_code}
//               </td>
//               <td className="sticky-col boq-th2">
//                 {serviceReport.boq_info.description}
//               </td>
//               <td className="sticky-col boq-th3">
//                 {serviceReport.boq_info.uom}
//               </td>
//               <td className="sticky-col boq-th4">
//                 {serviceReport.boq_info.qty}
//               </td>
//               <td className="sticky-col boq-th5">
//                 ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
//               </td>
//               <td className="sticky-col boq-th6">
//                 ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
//               </td>

//               {months.map((month, monthIndex) => {
//                 const monthData = serviceReport.breakdown.find(
//                   (m) => m.month === month
//                 );

//                 return monthWeeksMap[month].map((weekLabel, weekIndex) => {
//                   const weekData =
//                     monthData?.weeks.find((w) => w.week === weekLabel) || null;

//                   return (
//                     <React.Fragment key={`${monthIndex}-${weekIndex}`}>
//                       <td>{weekData ? weekData.planned_qty : "-"}</td>
//                       <td>{weekData ? weekData.completed_qty : "-"}</td>
//                       <td
//                         className={
//                           weekData && weekData.variance < 0
//                             ? "new_billing_ui_negative_variance"
//                             : ""
//                         }
//                       >
//                         {weekData ? weekData.variance : "-"}
//                       </td>
//                       <td>
//                         {weekData ? `${weekData.completion_percentage}%` : "-"}
//                       </td>
//                       <td>
//                         {weekData
//                           ? `₹ ${formatNumber(weekData.amount_with_gst)}`
//                           : "-"}
//                       </td>
//                     </React.Fragment>
//                   );
//                 });
//               })}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     );
//   };

//   return (
//     <>
//       <div
//         className={`data-list-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="data-edit-form-content">
//           <div className="data-edit-form-header">
//             <div className="data-edit-form-header-content">
//               <div className="data-edit-form-heading-content-left-side">
//                 <Tooltip title="Back" arrow>
//                   <IoMdArrowBack
//                     className="back-company"
//                     onClick={handleBack}
//                   />
//                 </Tooltip>
//                 Billing Report
//               </div>
//               <div className="new_billing_ui_header_right">
//                 <div className="new_billing_ui_radio_group">
//                   <label className="new_billing_ui_radio_label">
//                     <input
//                       type="radio"
//                       name="frequency"
//                       value="weekly"
//                       checked={billingFrequency === "weekly"}
//                       onChange={() => handleFrequencyChange("weekly")}
//                     />
//                     <span>Weekly</span>
//                   </label>
//                   <label className="new_billing_ui_radio_label">
//                     <input
//                       type="radio"
//                       name="frequency"
//                       value="monthly"
//                       checked={billingFrequency === "monthly"}
//                       onChange={() => handleFrequencyChange("monthly")}
//                     />
//                     <span>Monthly</span>
//                   </label>
//                 </div>
//                 <button
//                   className="new_billing_ui_export_btn"
//                   onClick={handleExport}
//                   disabled={isExporting}
//                 >
//                   <MdFileDownload size={20} />
//                   {isExporting ? "Exporting..." : "Export"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="header-separator"></div>

//         {billingData && (
//           <div className="new_billing_ui_project_info">
//             <div className="new_billing_ui_info_item">
//               <strong>Project:</strong> {billingData.project_info.project_name}
//             </div>
//             <div className="new_billing_ui_info_item">
//               <strong>Duration:</strong>{" "}
//               {new Date(
//                 billingData.project_info.start_date
//               ).toLocaleDateString()}{" "}
//               to{" "}
//               {new Date(
//                 billingData.project_info.end_date
//               ).toLocaleDateString()}
//             </div>
//             <div className="new_billing_ui_info_item">
//               <strong>Service Codes:</strong>{" "}
//               {billingData.total_service_codes}
//             </div>
//           </div>
//         )}

//         <div className="data-list-body">
//           <div className="data-list-scroll-body-boq">
//             <div className="data-list-table-boq">
//               {loading ? (
//                 <div className="loader-container">
//                   <div className="loader"></div>
//                   <div>Loading...</div>
//                 </div>
//               ) : billingData &&
//                 billingData.service_code_reports.length > 0 ? (
//                 billingFrequency === "monthly" ? (
//                   renderHorizontalMonthlyView()
//                 ) : (
//                   renderHorizontalWeeklyView()
//                 )
//               ) : (
//                 <div>No billing data found.</div>
//               )}
//             </div>
//           </div>
//         </div>

//         {billingData && billingData.overall_summary && (
//           <div className="new_boq_totals_container">
//             <div className="new_boq_totals_row">
//               <div className="new_boq_totals_card">
//                 <div>
//                   <div className="new_boq_totals_title">Total Planned Qty</div>
//                   <div className="new_boq_totals_value">
//                     {billingData.overall_summary.total_planned_qty}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="new_boq_totals_title">
//                     Total Completed Qty
//                   </div>
//                   <div className="new_boq_totals_value">
//                     {billingData.overall_summary.total_completed_qty}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="new_boq_totals_title">Completion %</div>
//                   <div className="new_boq_totals_value">
//                     {billingData.overall_summary.completion_percentage}%
//                   </div>
//                 </div>
//               </div>

//               <div className="new_boq_totals_card">
//                 <div>
//                   <div className="new_boq_totals_title">
//                     Amount (without GST)
//                   </div>
//                   <div className="new_boq_totals_value">
//                     ₹{" "}
//                     {formatNumber(
//                       billingData.overall_summary.total_amount_without_gst
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="new_boq_totals_card gst">
//                 <div>
//                   <div className="new_boq_totals_title">GST Amount</div>
//                   <div className="new_boq_totals_value">
//                     ₹{" "}
//                     {formatNumber(
//                       billingData.overall_summary.total_gst_amount
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="new_boq_totals_card">
//                 <div>
//                   <div className="new_boq_totals_title">
//                     Total Amount (with GST)
//                   </div>
//                   <div className="new_boq_totals_value">
//                     ₹{" "}
//                     {formatNumber(
//                       billingData.overall_summary.total_amount_with_gst
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default BOQAddQtyDetails;

import React, { useState, useEffect } from "react";
import "./BOQAddDetails.css";
import axios from "axios";
import API_URL from "../../../src/Config";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { MdFileDownload } from "react-icons/md";

function BOQAddQtyDetails({ isSidebarExpanded }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { id, billing_frequency } = useParams();
  const navigate = useNavigate();
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [billingFrequency, setBillingFrequency] = useState(
    billing_frequency || "weekly"
  );
  const [billingData, setBillingData] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, type = "success") => {
    setSnackbarMessage(message);
    setSeverity(type);
    setSnackbarOpen(true);
  };

  const fetchBillingReport = async (frequency) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/billing_report`, {
        headers: { Authorization: authKey },
        params: {
          billing_frequency: frequency,
          project_id: id,
        },
      });

      console.log("Billing Report Data:", response.data);
      setBillingData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching billing report:", error.message);
      setError(error.message);
      showSnackbar("Failed to fetch billing report", "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && billingFrequency) {
      fetchBillingReport(billingFrequency);
    }
  }, [id, billingFrequency]);

  const handleFrequencyChange = (frequency) => {
    setBillingFrequency(frequency);
    // Update URL to reflect frequency change
    navigate(`/boq-add-details/${id}/${frequency}`, { replace: true });
  };

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/billing_report/export`, {
        headers: { Authorization: authKey },
        params: {
          billing_frequency: billingFrequency,
          project_id: id,
        },
        responseType: "blob",
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      link.setAttribute(
        "download",
        `Billing_Report_${billingFrequency}_${timestamp}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showSnackbar("Report exported successfully", "success");
      setIsExporting(false);
    } catch (error) {
      console.error("Error exporting report:", error.message);
      showSnackbar("Failed to export report", "error");
      setIsExporting(false);
    }
  };

  const handleBack = () => {
    navigate("/amc-projects");
  };

  function formatNumber(number) {
    if (!number) return "0";
    const parts = number.toString().split(".");
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? "." + parts[1] : "";

    let formattedIntegerPart = "";
    let lakhFlag = false;
    let croreFlag = false;
    let croreLakhFlag = false;

    for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
      if (count === 3 && !lakhFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        lakhFlag = true;
      }

      if (count === 2 && lakhFlag && !croreFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        croreFlag = true;
      }

      if (count === 2 && croreFlag && !croreLakhFlag) {
        formattedIntegerPart = "," + formattedIntegerPart;
        count = 0;
        croreLakhFlag = true;
      }

      formattedIntegerPart = integerPart[i] + formattedIntegerPart;
    }

    return formattedIntegerPart + decimalPart;
  }

  // Get all unique months from the breakdown data
  const getAllMonths = () => {
    if (!billingData || !billingData.service_code_reports.length) return [];

    const monthsSet = new Set();

    billingData.service_code_reports.forEach((serviceReport) => {
      if (billingFrequency === "monthly") {
        serviceReport.breakdown.forEach((period) => {
          monthsSet.add(period.period);
        });
      } else {
        // weekly
        serviceReport.breakdown.forEach((month) => {
          monthsSet.add(month.month);
        });
      }
    });

    return Array.from(monthsSet);
  };

  // Get all unique weeks across all months (for weekly view)
  const getAllWeeksFlat = () => {
    if (!billingData || !billingData.service_code_reports.length) return [];

    const weeksArray = [];
    const processedWeeks = new Set();
      console.log("billingDatabillingData:", billingData);
    billingData.service_code_reports.forEach((serviceReport) => {
      console.log("Processing service report:", serviceReport);
      serviceReport.breakdown.forEach((month) => {
        if (month.weeks) {
          month.weeks.forEach((week) => {
            const weekKey = `${month.month}-${week.week_label}`;
            if (!processedWeeks.has(weekKey)) {
              processedWeeks.add(weekKey);
              weeksArray.push({
                month: month.month,
                week: week.week_label,
                label: `${month.month} - ${week.week_label}`
              });
            }
          });
        }
      });
    });

    return weeksArray;
  };

  const renderHorizontalMonthlyView = () => {
    if (!billingData || !billingData.service_code_reports.length) return null;

    const months = getAllMonths();

    return (
      <table className="excel-table">
        <thead>
          <tr>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th1 new_boq_table_th"
            >
              Service Code
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th2 new_boq_table_th"
            >
              Description
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th3 new_boq_table_th"
            >
              UOM
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th4 new_boq_table_th"
            >
              Quantity
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th5 new_boq_table_th"
            >
              Unit Rate
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th5 new_boq_table_th"
            >
              GST
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th6 new_boq_table_th"
            >
              Total Amount (with GST)
            </th>

            {months.map((month, index) => (
              <th colSpan="5" key={index} className="new_boq_table_th new_billing_ui_month_header">
                {month}
              </th>
            ))}
          </tr>
          <tr>
            {months.map((month, monthIndex) => (
              <React.Fragment key={monthIndex}>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Planned
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Completed
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Variance
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Completion %
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header week_separator_billing">
                  Amount (Incl. GST)
                </th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {billingData.service_code_reports.map((serviceReport, index) => (
            <tr key={index}>
              <td className="sticky-col boq-th1">
                {serviceReport.service_code}
              </td>
              <td className="sticky-col boq-th2">
                {serviceReport.boq_info.description}
              </td>
              <td className="sticky-col boq-th3">
                {serviceReport.boq_info.uom}
              </td>
              <td className="sticky-col boq-th4">
                {serviceReport.boq_info.qty}
              </td>
              <td className="sticky-col boq-th5">
                ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
              </td>
              <td className="sticky-col boq-th4">
                {serviceReport.boq_info.gst}
              </td>
              <td className="sticky-col boq-th6 week_separator_billing">
                ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
              </td>

              {months.map((month, monthIndex) => {
                const periodData = serviceReport.breakdown.find(
                  (p) => p.period === month
                );

                return (
                  <React.Fragment key={monthIndex}>
                    <td>{periodData ? periodData.planned_qty : "-"}</td>
                    <td className="bg_complete">{periodData ? periodData.completed_qty : "-"}</td>
                    <td
                      className={
                        periodData && periodData.variance < 0
                          ? "new_billing_ui_negative_variance"
                          : ""
                      }
                    >
                      {periodData ? periodData.variance : "-"}
                    </td>
                    <td>
                      {periodData ? `${periodData.completion_percentage}%` : "-"}
                    </td>
                    <td className="week_separator_billing">
                      {periodData
                        ? `₹ ${formatNumber(periodData.amount_with_gst)}`
                        : "-"}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderHorizontalWeeklyView = () => {
    if (!billingData || !billingData.service_code_reports.length) return null;

    const allWeeks = getAllWeeksFlat();

    return (
      <table className="excel-table">
        <thead>
          <tr>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th1 new_boq_table_th"
            >
              Service Code
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th2 new_boq_table_th"
            >
              Description
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th3 new_boq_table_th"
            >
              UOM
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th4 new_boq_table_th"
            >
              Quantity
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th5 new_boq_table_th"
            >
              Unit Rate
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th5 new_boq_table_th"
            >
              GST
            </th>
            <th
              rowSpan="2"
              className="sticky-col sticky-back boq-th6 new_boq_table_th week_separator_billing"
            >
              Total Amount (with GST)
            </th>

            {allWeeks.map((weekInfo, index) => (
              <th colSpan="5" key={index} className="new_boq_table_th new_billing_ui_week_header week_separator_billing">
                {weekInfo.label}
              </th>
            ))}
          </tr>
          <tr>
            {allWeeks.map((weekInfo, weekIndex) => (
              <React.Fragment key={weekIndex}>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Planned
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Completed
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Variance
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header">
                  Completion %
                </th>
                <th className="new_boq_table_th new_billing_ui_sub_header week_separator_billing">
                  Amount (Incl. GST)
                </th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {billingData.service_code_reports.map((serviceReport, index) => (
            <tr key={index}>
              <td className="sticky-col boq-th1">
                {serviceReport.service_code}
              </td>
              <td className="sticky-col boq-th2">
                {serviceReport.boq_info.description}
              </td>
              <td className="sticky-col boq-th3">
                {serviceReport.boq_info.uom}
              </td>
              <td className="sticky-col boq-th4">
                {serviceReport.boq_info.qty}
              </td>
              <td className="sticky-col boq-th5">
                ₹ {formatNumber(serviceReport.boq_info.unit_rate)}
              </td>
              <td className="sticky-col boq-th4">
                {serviceReport.boq_info.gst}
              </td>
              <td className="sticky-col boq-th6">
                ₹ {formatNumber(serviceReport.boq_info.total_amount_with_gst)}
              </td>

              {allWeeks.map((weekInfo, weekIndex) => {
                // Find the month data
                const monthData = serviceReport.breakdown.find(
                  (m) => m.month === weekInfo.month
                );
                
                console.log("monthData for week:", weekInfo, monthData);
                // Find the week data within that month
                const weekData = monthData?.weeks?.find(
                  (w) => w.week_label === weekInfo.week
                ) || null;

                return (
                  <React.Fragment key={weekIndex}>
                    <td>{weekData ? weekData.planned_qty : "-"}</td>
                    <td className="bg_complete" style={{backgroundColor:"#00800024"}}>{weekData ? weekData.completed_qty : "-"}</td>
                    <td
                      className={
                        weekData && weekData.variance < 0
                          ? "new_billing_ui_negative_variance"
                          : ""
                      }
                    >
                      {weekData ? weekData.variance : "-"}
                    </td>
                    <td>
                      {weekData ? `${weekData.completion_percentage}%` : "-"}
                    </td>
                    <td className="week_separator_billing">
                      {weekData
                        ? `₹ ${formatNumber(weekData.amount_with_gst)}`
                        : "-"}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-edit-form-content">
          <div className="data-edit-form-header">
            <div className="data-edit-form-header-content">
              <div className="data-edit-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBack}
                  />
                </Tooltip>
                Billing Report
              </div>
              <div className="new_billing_ui_header_right">
                <div className="new_billing_ui_radio_group">
                  <label className="new_billing_ui_radio_label">
                    <input
                      type="radio"
                      name="frequency"
                      value="weekly"
                      checked={billingFrequency === "weekly"}
                      onChange={() => handleFrequencyChange("weekly")}
                    />
                    <span>Weekly</span>
                  </label>
                  <label className="new_billing_ui_radio_label">
                    <input
                      type="radio"
                      name="frequency"
                      value="monthly"
                      checked={billingFrequency === "monthly"}
                      onChange={() => handleFrequencyChange("monthly")}
                    />
                    <span>Monthly</span>
                  </label>
                </div>
                <button
                  className="new_billing_ui_export_btn"
                  onClick={handleExport}
                  disabled={isExporting}
                >
                  <MdFileDownload size={20} />
                  {isExporting ? "Exporting..." : "Export"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="header-separator"></div>

        {billingData && (
          <div className="new_billing_ui_project_info">
            <div className="new_billing_ui_info_item">
              <strong>Project:</strong> {billingData.project_info.project_name}
            </div>
            <div className="new_billing_ui_info_item">
              <strong>Duration:</strong>{" "}
              {new Date(
                billingData.project_info.start_date
              ).toLocaleDateString()}{" "}
              to{" "}
              {new Date(
                billingData.project_info.end_date
              ).toLocaleDateString()}
            </div>
            <div className="new_billing_ui_info_item">
              <strong>Service Codes:</strong>{" "}
              {billingData.total_service_codes}
            </div>
          </div>
        )}

        <div className="data-list-body">
          <div className="data-list-scroll-body-boq">
            <div className="data-list-table-boq">
              {loading ? (
                <div className="loader-container">
                  <div className="loader"></div>
                  <div>Loading...</div>
                </div>
              ) : billingData &&
                billingData.service_code_reports.length > 0 ? (
                billingFrequency === "monthly" ? (
                  renderHorizontalMonthlyView()
                ) : (
                  renderHorizontalWeeklyView()
                )
              ) : (
                <div>No billing data found.</div>
              )}
            </div>
          </div>
        </div>

        {billingData && billingData.overall_summary && (
          <div className="new_boq_totals_container">
            <div className="new_boq_totals_row">
              <div className="new_boq_totals_card new_boq_totals_card1">
                <div>
                  <div className="new_boq_totals_title">Total Planned Qty</div>
                  <div className="new_boq_totals_value">
                    {billingData.overall_summary.total_planned_qty}
                  </div>
                </div>
                <div>
                  <div className="new_boq_totals_title">
                    Total Completed Qty
                  </div>
                  <div className="new_boq_totals_value">
                    {billingData.overall_summary.total_completed_qty}
                  </div>
                </div>
                <div>
                  <div className="new_boq_totals_title">Completion %</div>
                  <div className="new_boq_totals_value">
                    {billingData.overall_summary.completion_percentage}%
                  </div>
                </div>
              </div>

              <div className="new_boq_totals_card new_boq_totals_card2">
                <div>
                  <div className="new_boq_totals_title">
                    Amount (without GST)
                  </div>
                  <div className="new_boq_totals_value">
                    ₹{" "}
                    {formatNumber(
                      billingData.overall_summary.total_amount_without_gst
                    )}
                  </div>
                </div>
              </div>

              <div className="new_boq_totals_card new_boq_totals_card2">
                <div>
                  <div className="new_boq_totals_title">GST Amount</div>
                  <div className="new_boq_totals_value">
                    ₹{" "}
                    {formatNumber(
                      billingData.overall_summary.total_gst_amount
                    )}
                  </div>
                </div>
              </div>

              <div className="new_boq_totals_card gst new_boq_totals_card2">
                <div>
                  <div className="new_boq_totals_title">
                    Total Amount (Incl. GST)
                  </div>
                  <div className="new_boq_totals_value">
                    ₹{" "}
                    {formatNumber(
                      billingData.overall_summary.total_amount_with_gst
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default BOQAddQtyDetails;